<template>
    <div class="wallet" v-if="true">
        <div class="row align-items-center funds-transfer__tit-page tit_page">
            <div class="col-12 col-lg-8">
                <h1>Comprovante de {{getComprovanteType()}}</h1>
                teste
            </div>
            <div class="col-12 col-lg-4">
                <div class="back back-hide float-md-right">
                    <router-link to="/investimentos/carteira-investimento" title="Voltar"><i>&nbsp;</i> voltar</router-link>
                </div>
            </div>
        </div>
        <hr class="divider">
        <div class="row justify-content-center">
            <div class="col-12 col-md-12 col-lg-7">

                <!-- COMPROVANTE DE REPAGAMENTO -->
                <div class="row align-items-center" v-if="true">
                    <div class="col-12 col-md-6 d-flex justify-content-sm-center justify-content-md-end">

                        <!-- INÍCIO COMPROVANTE -->
                        <div class="coupon" id="cupom">
                            <div class="coupon__head"></div>
                            <div class="coupon__body">
                                <img src="/static/assets/images/logotipo-iouu.png" width="70" alt="Logotipo IOUU">
                                <p class="id">COMPROVANTE {{this.idComprovante}}</p>
                                <div class="date">
                                    RECEBIDO EM: <span>{{formatDate(this.transferencia.Data)}}</span>
                                </div>
                                <ul>
                                    <li>De: <span>{{NomeEmpresa}}</span></li>
                                    <li>Parcela: <span>{{RecebimentoParcela}}</span></li>
                                    <li>Principal: <span>R$ {{CalcCapital}}</span></li>
                                     <li v-if="this.transferencia.Ipmt">Juros: <span>R$ {{this.formatCurrency(this.transferencia.Ipmt)}} </span></li>
                                     <li v-if="!this.transferencia.Ipmt">Juros: <span>+ R$ {{CalcJuros}}</span></li>

                                    <li v-if="CalcMulta > 0">Multa por atraso: <span>+ R$ {{this.formatCurrency(CalcMulta)}}</span></li>

                                    <li>Valor bruto pago: <span>R$ {{valor}}</span></li>
                                    <li v-if="this.transferencia.IR > 0">IR: <span>R$ {{impostoRenda}}</span></li>
                                    <li>CNPJ: <span>{{DocumentoEmpresa}}</span></li>
                                </ul>
                                <ul>
                                    <li>Para: <span>{{nome}}</span></li>
                                    <li v-if="this.transferencia.ValorLiquido > 0">Valor Liquido Recebido: <span>R$ {{valorLiquido}}</span></li>
                                    <li v-else>Valor Recebido: <span>R$ {{valor}}</span></li>
                                    <li>CPF/CNPJ: <span>{{documento}}</span></li>
                                </ul>
                            </div>
                            <div class="coupon__foot"></div>
                        </div>
                        <!-- FINAL COMPROVANTE -->
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="wallet__description">
                            <h2>Recebimento realizado</h2>
                            <div>
                                <p>
                                  <strong>Principal</strong>
                                  <span class="text-primary">R$ {{CalcCapital}}</span>
                                </p>
                                <p>
                                  <strong>Juros</strong>
                                  <span class="text-primary" v-if="this.transferencia.Ipmt">+ {{this.formatCurrency(this.transferencia.Ipmt)}} </span>
                                  <span class="text-primary" v-if="!this.transferencia.Ipmt">+ R$ {{CalcJuros}} </span>
                                </p>
                                <p v-if="CalcMulta > 0">
                                  <strong>Multa por atraso</strong>
                                  <span class="text-primary">+ R$ {{this.formatCurrency(CalcMulta)}}</span>
                                </p>
                                <p>
                                  <strong v-if="CalcMulta > 0">Valor bruto pago (Principal + Juros + Multa)</strong>
                                  <strong v-if="CalcMulta == 0">Valor bruto pago (Principal + Juros)</strong>
                                  <span class="text-success">R$ {{valor}}</span>
                                </p>
                            </div>
                            <button class="btn btn-outline-secondary btn-lg" title="Imprimir comprovante" @click="printPdf()"><i class="fas fa-print"></i> Imprimir comprovante</button>
                            <button class="btn btn-outline-secondary btn-lg" title="Salvar comprovante" @click="savePdf()"><i class="fas fa-download"></i> Salvar comprovante</button>
                        </div>
                    </div>
                </div>
                <!-- :::::::::::::::::::: -->

                <!-- COMPROVANTE DE AGENDAMENTO -->
                <div class="row align-items-center" v-else-if="type === 'DEBITO' && !this.transferencia.ReInvestimento">
                    <div class="col-12 col-md-6 d-flex justify-content-sm-center justify-content-md-end">

                        <!-- INÍCIO COMPROVANTE -->
                        <div class="coupon" id="cupom">
                            <div class="coupon__head"></div>
                            <div class="coupon__body">
                                <img src="/static/assets/images/logotipo-iouu.png" width="70" alt="Logotipo IOUU">
                                <p class="id">COMPROVANTE {{this.idComprovante}}</p>
                                <div class="date">
                                    AGENDADO EM: <span>{{formatDate(this.transferencia.DataTransferencia)}}</span>
                                </div>
                                <ul>
                                    <li>De: <span>IOUU Tecnologia e Serviços Financeiros</span></li>
                                    <li>Valor: <span>R$ {{valor}}</span></li>
                                    <li>TED: <span>- R$ {{this.ted}}</span></li>
                                    <li>CNPJ: <span>26.484.548/0001-48</span></li>
                                </ul>
                                <ul>
                                    <li>Para: <span>{{nome}}</span></li>
                                    <li>Valor: <span>R$ {{valorComTed}}</span></li>
                                    <li>CPF/CNPJ: <span>{{documento}}</span></li>
                                    <li>Banco: <span>{{nomeBanco}}</span></li>
                                    <li>Agência: {{agencia}} <span>Conta: {{NumeroConta}}</span></li>
                                </ul>
                            </div>
                            <div class="coupon__foot"></div>
                        </div>
                        <!-- FINAL COMPROVANTE -->

                    </div>
                    <div class="col-12 col-md-6">
                        <div class="wallet__description">
                            <h2>Agendamento realizado</h2>
                            <div>
                                <p>
                                    <strong>Valor solicitado</strong>
                                    <span class="text-secondary">R$ {{valor}}</span>
                                </p>
                                <p>
                                    <strong>Custo de TED</strong>
                                    <span class="text-danger"> R$ {{this.ted}}</span>
                                </p>
                                <p>
                                    <strong>Valor total da transferência</strong>
                                    <span class="text-primary">R$ {{valorComTed}}</span>
                                </p>
                            </div>
                            <p class="small">
                                Transferência para: {{nomeBanco}}<br>
                                Agência: {{agencia}} - {{tipoConta}}: {{NumeroConta}}
                            </p>
                            <p class="small">
                              Em caso de finais de semana e feriados a transferência<br/>
                              é agendada para o próximo dia útil e efetivada em até dois dias úteis.
                            </p>
                            <button class="btn btn-outline-secondary btn-lg" title="Imprimir comprovante" @click="printPdf()"><i class="fas fa-print"></i> Imprimir comprovante</button>
                            <button class="btn btn-outline-secondary btn-lg" title="Salvar comprovante" @click="savePdf()"><i class="fas fa-download"></i> Salvar comprovante</button>
                        </div>
                    </div>
                </div>
                <!-- :::::::::::::::::::::::: -->

                 <!-- COMPROVANTE DE AGENDAMENTO -->
                <div class="row align-items-center" v-else-if="type === 'DEBITO' && this.transferencia.ReInvestimento">
                    <div class="col-12 col-md-6 d-flex justify-content-sm-center justify-content-md-end">

                        <!-- INÍCIO COMPROVANTE -->
                        <div class="coupon" id="cupom">
                            <div class="coupon__head"></div>
                            <div class="coupon__body">
                                <img src="/static/assets/images/logotipo-iouu.png" width="70" alt="Logotipo IOUU">
                                <p class="id">COMPROVANTE {{this.idComprovante}}</p>
                               <div class="date">
                                    REINVESTIDO EM: <span>{{formatDate(this.transferencia.Data)}}</span>
                                </div>
                                <ul>
                                    <li>Empresa: <span>{{NomeEmpresa}}</span></li>
                                    <li>Valor: <span>R$ {{valor}}</span></li>
                                    <li>CNPJ: <span>{{DocumentoEmpresa}}</span></li>
                                </ul>
                                
                            </div>
                            <div class="coupon__foot"></div>
                        </div>
                        <!-- FINAL COMPROVANTE -->

                    </div>
                    <div class="col-12 col-md-6">
                        <div class="wallet__description">
                            <h2>Reinvestimento realizado</h2>
                            <div>
                               
                                <p>
                                    <strong>Valor total da transferência</strong>
                                    <span class="text-primary">R$ {{valor}}</span>
                                </p>
                            </div>
                                               
                            <button class="btn btn-outline-secondary btn-lg" title="Imprimir comprovante" @click="printPdf()"><i class="fas fa-print"></i> Imprimir comprovante</button>
                            <button class="btn btn-outline-secondary btn-lg" title="Salvar comprovante" @click="savePdf()"><i class="fas fa-download"></i> Salvar comprovante</button>
                        </div>
                    </div>
                </div>
                <!-- :::::::::::::::::::::::: -->
                
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import ApiClient from '../utils/api-client'
import * as mutationTypes from '@/store/mutation-types.js'
import Masker from '../utils/masker'
import pdf from '../utils/pdf-helper'

    export default {

        data() {
            return {
                investor: null,
                tranferencia: null,
                type: "teste",
                idComprovante: "",
                loading: false,
                loadingTransaction: false,
                loadingBank: false,
                ted: "0,00",
                currentPage: 0,
                pageCount: 0,
            }
        },

        methods: {
            getComprovanteType() {
              let tipoComprovante;

              if(this.type === "CREDITO") {
                tipoComprovante = "Repagamento"
              } else {
                tipoComprovante = "Transferência"
              }

              return tipoComprovante;
            },
            FV(rate, periods, payment, value, type) {
              // Credits: algorithm inspired by Apache OpenOffice

              // Initialize type
              type = (typeof type === 'undefined') ? 0 : type;

              // Evaluate rate (TODO: replace with secure expression evaluator)
              rate = eval(rate);

              // Return future value
              var result;
              if (rate === 0) {
                result = value + payment * periods;
              } else {
                var term = Math.pow(1 + rate, periods);
                if (type === 1) {
                  result = value * term + payment * (1 + rate) * (term - 1.0) / rate;
                } else {
                  result = value * term + payment * (term - 1) / rate;
                }
              }

              // result = Math.round(result * 100) / 100;

              return -result;
            },
            IPMT(rate, period, periods, present, future, type) {
              // Credits: algorithm inspired by Apache OpenOffice

              // Initialize type
              type = (typeof type === 'undefined') ? 0 : type;

              // Initialize future
              future = (typeof future === 'undefined') ? 0 : future;

              // Evaluate rate and periods (TODO: replace with secure expression evaluator)
              rate = eval(rate);
              periods = eval(periods);

              // Compute payment
              var payment = this.PMT(rate, periods, present, future, type);

              // Compute interest
              var interest;
              if (period === 1) {
                if (type === 1) {
                  interest = 0;
                } else {
                  interest = -present;
                }
              } else {
                if (type === 1) {
                  interest = this.FV(rate, period - 2, payment, present, 1) - payment;
                } else {
                  interest = this.FV(rate, period - 1, payment, present, 0);
                }
              }

              var result = interest * rate;
              // result = Math.round(result * 100) / 100;

              // Return interest
              return interest * rate;
            },
            PMT(rate, periods, present, future, type) {
              // Credits: algorithm inspired by Apache OpenOffice

              // Initialize type
              type = (typeof type === 'undefined') ? 0 : type;

              // Initialize future
              future = 0;

              // Evaluate rate (TODO: replace with secure expression evaluator)
              rate = eval(rate);

              // Return payment
              var result;
              if (rate === 0) {
                result = (present + future) / periods;
              } else {
                var term = Math.pow(1 + rate, periods);
              if (type === 1) {
                result = (future * rate / (term - 1) + present * rate / (1 - 1 / term)) / (1 + rate);
              } else {
                result = future * rate / (term - 1) + present * rate / (1 - 1 / term);
                }
              }

              // result = Math.round(result * 100) / 100;

              return -result;
            },
            formatCurrency(value) {
                if(value != null)
                    return value.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2});

                return 0;
            },
            formatReal(num) {
                let real;
                real = parseFloat(num.replace(/[^\d]+/g, '')) / 100;
                return real;
            },
            formatDate(date) {
              let spliter = date.split("T")
              let newDate = spliter[0].split('-')
              let time = spliter[1].split(':')

              return `${newDate[2]}/${newDate[1]}/${newDate[0]}`
            },
            savePdf() {
              pdf.Save('cupom', this.idComprovante);
            },
            printPdf() {
              pdf.Print('cupom', this.idComprovante);
            },
            getIndiceFatura(fatura) {
              return fatura != null ? fatura.IndiceFatura + 1 : ""
            },
            //tagueamento GA
            taggingGA() {
              this.$ga.page({
                page: '/carteira-investimento/comprovante/:id',
                title: 'Comprovante',
              })
            },
        },
        computed: {

            CalcLiquid: function() {
              let ipmt,
                  RetornoBrutoMensal = this.transferencia.SolicitacaoID.RetornoBrutoMensal / 100,
                  IndiceFatura = this.getIndiceFatura(this.transferencia.FaturaID),
                  Prazo = this.transferencia.SolicitacaoID.Prazo,
                  Valor = this.transferencia.ReservaInvestimentoID.Valor,
                  aliqIR,
                  Ir;

                  ipmt = -this.IPMT(RetornoBrutoMensal, IndiceFatura, Prazo, Valor);
                  ipmt = Math.round(ipmt * 100) / 100;

                  if(IndiceFatura >= 1 && IndiceFatura < 6) aliqIR = 0.225;
                  else if(IndiceFatura >= 6 && IndiceFatura < 12) aliqIR = 0.2;
                  else if(IndiceFatura >= 12 && IndiceFatura < 24) aliqIR = 0.175;
                  else aliqIR = 0.15;

                  Ir = ipmt * aliqIR;

              return this.formatCurrency(this.transferencia.Valor - Ir)
            },
            CalcIR: function() {
              let ipmt,
                  RetornoBrutoMensal = this.transferencia.SolicitacaoID.RetornoBrutoMensal / 100,
                  IndiceFatura = this.getIndiceFatura(this.transferencia.FaturaID),
                  Prazo = this.transferencia.SolicitacaoID.Prazo,
                  Valor = this.transferencia.ReservaInvestimentoID.Valor,
                  aliqIR;

                  ipmt = -this.IPMT(RetornoBrutoMensal, IndiceFatura, Prazo, Valor);
                  ipmt = Math.round(ipmt * 100) / 100;

                  if(IndiceFatura >= 1 && IndiceFatura < 6) aliqIR = 0.225;
                  else if(IndiceFatura >= 6 && IndiceFatura < 12) aliqIR = 0.2;
                  else if(IndiceFatura >= 12 && IndiceFatura < 24) aliqIR = 0.175;
                  else aliqIR = 0.15;


              return this.formatCurrency(ipmt * aliqIR);
            },
            CalcJuros: function() {
               let ipmt,
                   RetornoBrutoMensal = this.transferencia.SolicitacaoID.RetornoBrutoMensal / 100,
                   IndiceFatura = this.getIndiceFatura(this.transferencia.FaturaID),
                   Prazo = this.transferencia.SolicitacaoID.Prazo,
                   Valor = this.transferencia.ReservaInvestimentoID.Valor;


               ipmt = -this.IPMT(RetornoBrutoMensal, IndiceFatura, Prazo, Valor);
               ipmt = Math.round(ipmt * 100) / 100;

               console.log(this.transferencia)

               return this.formatCurrency(ipmt);
            },

            CalcMulta: function() {
              if(this.transferencia.Juros != undefined && this.transferencia.Juros  > 0)
                return this.transferencia.Juros

               return 0;
            },
            CalcCapital: function() {
              let ipmt,
                  RetornoBrutoMensal = this.transferencia.SolicitacaoID.RetornoBrutoMensal / 100,
                  IndiceFatura = this.getIndiceFatura(this.transferencia.FaturaID),
                  Prazo = this.transferencia.SolicitacaoID.Prazo,
                  Valor = this.transferencia.ReservaInvestimentoID.Valor;

                ipmt = -this.IPMT(RetornoBrutoMensal, IndiceFatura, Prazo, Valor);
                ipmt = Math.round(ipmt * 100) / 100;

                if(this.transferencia.Ipmt > 0) ipmt = this.transferencia.Ipmt;

               if(this.transferencia.Juros == undefined || this.transferencia.Juros == null)
                 this.transferencia.Juros = 0;

              return this.formatCurrency((this.transferencia.Valor - this.transferencia.Juros) - ipmt);
            },
            NomeEmpresa: function() {
              return this.transferencia.SolicitacaoID.TipoEmprestimo === "emprestimo-de-impacto" ? this.transferencia.SolicitacaoID.Impacto.NomeEmpresa : this.transferencia.SolicitacaoID.Empresa.RazaoSocial;
            },
            DocumentoEmpresa: function() {
              return Masker.maskCpf(this.transferencia.SolicitacaoID.Documento);
            },
            RecebimentoParcela: function() {
              return `${this.getIndiceFatura(this.transferencia.FaturaID)} / ${this.transferencia.SolicitacaoID.Prazo}`
            },
            valor: function() {
                return this.formatCurrency(this.transferencia.Valor)
            },
            valorLiquido: function() {
                return this.formatCurrency(this.transferencia.ValorLiquido)
            },
            impostoRenda: function() {
                return this.formatCurrency(this.transferencia.IR)
            },
            valorComTed: function() {
                return this.formatCurrency(this.transferencia.Valor - this.formatReal(this.ted))
            },
            nome: function() {
                return this.investor.NomeCompleto;
            },
            documento: function() {
                return Masker.maskCpf(this.investor.Cpf);
            },
            nomeBanco: function() {
                if(this.investor != null && this.investor.DadosBancarios != null && this.bank != null)
                    return this.bank.length > 0 ? this.bank[0].nome : `Outro - Codigo do banco: ${this.investor.DadosBancarios.CodigoBanco}`

                return ""
            },
            tipoConta: function() {
                if(this.transferencia != null && this.transferencia.DadosBancarios != null)
                    return this.transferencia.DadosBancarios.TipoConta  === 1 ? "Conta Corrente" : "Conta Poupança"
                return "";
            },
            NumeroConta: function() {
                if(this.transferencia != null && this.transferencia.DadosBancarios != null)
                    return this.transferencia.DadosBancarios.Conta
                return ""
            },
            agencia: function() {

                if(this.transferencia != null && this.transferencia.DadosBancarios != null)
                    return this.transferencia.DadosBancarios.Agencia
                return ""
            }
        },
        beforeCreate() {

          this.type = this.$route.query.type;

          this.$store.commit(mutationTypes.START_LOADING);
            
          ApiClient.getInvestor()
            .then(response => {
                this.investor = response;

                ApiClient.getComprovante(this.$route.params.id)
                .then(response => {
                    this.idComprovante = this.$route.params.id;
                    this.transferencia = response.data;

                    if(this.transferencia.ReservaInvestimentoID != null && this.transferencia.ReservaInvestimentoID.Valor == this.transferencia.ReservaInvestimentoID.ReInvestimento) {

                      this.transferencia.ReInvestimento = true;

                    }
                    
                    this.loadingTransaction = true;

                   if((new Date(this.transferencia.Data)).getFullYear() > 2018) {

                    this.ted = "0,00";

                   } else {

                    this.ted = "2,00";

                   }

                    if(this.type === "DEBITO" && !this.transferencia.ReInvestimento) {

                      ApiClient.getWalletBank(this.transferencia.DadosBancarios.CodigoBanco)
                      .then(response => {

                        this.bank = response.data;
                        this.loadingBank = true;

                      })
                    } else {
                      
                      this.loadingBank = true;

                    }

                })

                console.log("teste")

                this.loading = true;
                this.$store.commit(mutationTypes.STOP_LOADING);
            })
            .catch((error) => {
                console.log("request fail", error);
                this.loading = true;
                this.$store.commit(mutationTypes.STOP_LOADING);
            })
        },
        async created(){
          //tagueamento GA
          await this.taggingGA();
        }
    }
</script>

<style lang="scss" scoped>
@import "../assets/styles/iouu/mixins";
  .btn-lg {
    @include brkp-01(1515px) {
      width: 60%;
      display: inline-block;
      font-size: 0.7rem;
    }

    &:last-of-type {
      @include brkp-01(1515px) {
        margin-top: 0.6rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/WalletReceipt.vue